import Vue from 'vue';
import DynamicContactForm from 'components/dynamic-contact-form/DynamicContactForm.vue';

Vue.component('dynamic-contact-form', DynamicContactForm);